module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJAQMAAADElqTgAAAABlBMVEUAAABhxkl+0pEkAAAAAXRSTlMAQObYZgAAAB5JREFUeF4txMEJAAAMArEboeM4nLOLfUggHMLknwIbGALbl+foVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/up.png
// module id = DQXs
// module chunks = 1